import { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import { getOverviewByTypeAndID } from '@containers/Admin/shared/ResourcesWrapper/service/overviewService';
import { RESOURCES } from '@shared/Resources/types';
import { RequiredSign } from '@shared/Resources/Monitor/shared/Titles/styles';
import Media from '@shared/Resources/shared/components/Media';
import MediaSelector from '../shared/MediaSelector';
import { MediaContainer, StyledMediaIcon } from './styles';

export const NON_REQUIRED_TYPES = {
  DEMO: 'Demo',
  LESSON: 'Lesson',
};

class MediaClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payload: props.payload,
    };
  }

  onPayloadChange = (payload) => {
    const { payload: currentPayload } = this.state;
    const newPayload = { ...payload, title: currentPayload.title };
    this.setState({ payload: newPayload });
    const { onChange } = this.props;
    onChange({
      valid: Boolean(payload.value) === Boolean(payload.id),
      value: _.get(payload, 'id', null),
      additionalData: _.get(payload, 'value', null),
    });
  };

  onItemSelect = async (item) => {
    const media = await getOverviewByTypeAndID(RESOURCES.MEDIA, item.id);
    this.onPayloadChange({ ...item, value: media.overview.value });
  };

  clearMedia = () => {
    this.onPayloadChange({});
  };

  renderMedia = (value) => (
    <div>
      <MediaContainer>
        <Media
          noHeader
          contentUrl={value}
          contentType="video"
          description="Demo"
        />
      </MediaContainer>
      <MediaSelector
        isVideoExisted
        onItemSelect={this.onItemSelect}
        onItemRemove={this.clearMedia}
      />
    </div>
  );

  renderSelection = () => <MediaSelector onItemSelect={this.onItemSelect} />;

  render() {
    const { payload } = this.state;
    const { className } = this.props;
    return (
      <div className={className || 'resource-item'}>
        {payload.title && (
          <>
            <StyledMediaIcon />
            <Text
              size={TEXT_SIZE.T2}
              weight="900"
              textColor={TEXT_COLOR.DARK_BLUE}
            >
              {payload.title}
            </Text>
            {!payload.value
              && payload.title !== NON_REQUIRED_TYPES.DEMO
              && payload.title !== NON_REQUIRED_TYPES.LESSON
              && <RequiredSign>*</RequiredSign>
            }
          </>
        )}
        {payload.value
          ? this.renderMedia(payload.value)
          : this.renderSelection()}
      </div>
    );
  }
}

MediaClient.propTypes = {
  payload: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default MediaClient;
